import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'
import type ShiftConfigForm from 'modules/shift_management/lib/forms/ShiftConfigForm'

import { ShiftConfigWithBreaksForm } from '../forms'
import DayPopover from './DayPopover'
import EmptyCellDisplay from './EmptyCellDisplay'
import RestDayDisplay from './RestDayDisplay'
import ShiftDisplay from './ShiftDisplay'
import ShiftPopover from './ShiftPopover'

export interface Props {
  dayShort: string
  dayLong: string
  weekIndex: number
  shiftsForms: ShiftConfigWithBreaksForm[]
  onAddShift: (day: number) => void
  onDeleteShift: (form: ShiftConfigForm) => void
  onAddBreak: (
    breakConfiguration: BreakConfigurationFragment,
    breakType: BreakType,
    form: ShiftConfigWithBreaksForm
  ) => void
  onDeleteBreak: (dayConfig: ShiftConfigWithBreaksForm, form: PlannedBreakForm) => void
  onAddRestDay: (weekday: number) => void
  onAddEmptyCell: (weekday: number) => void
}

const DayInput = ({
  dayShort,
  dayLong,
  weekIndex,
  shiftsForms,
  onAddShift,
  onDeleteShift,
  onAddBreak,
  onDeleteBreak,
  onAddRestDay,
  onAddEmptyCell,
}: Props) => {
  const firstForm = shiftsForms[0]

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      padding="s16"
      background="grey000White"
      alignItems="flexStart"
      aria-label={dayLong}
    >
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        width="full"
        paddingY="s12"
        padding="s8"
      >
        <Text.Normal color="grey1000" weight="medium">
          {dayLong}
        </Text.Normal>
        {firstForm && (
          <DayPopover
            form={firstForm}
            onAddShift={() => onAddShift(weekIndex)}
            onAddRestDay={() => onAddRestDay(weekIndex)}
            onAddEmptyCell={() => onAddEmptyCell(weekIndex)}
          />
        )}
      </Box>
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
        width="full"
        gap="s16"
      >
        {shiftsForms.map((form, index) => {
          const { shiftConfig } = form
          return (
            <>
              {shiftConfig.isRestDay && <RestDayDisplay key={`restDay-${index}-${dayShort}`} />}
              {shiftConfig.isEmptyCell && (
                <EmptyCellDisplay key={`emptyCell-${index}-${dayShort}`} />
              )}
              {shiftConfig.isShift && (
                <ShiftDisplay
                  key={index}
                  form={form}
                  onDeleteBreak={onDeleteBreak}
                  popover={
                    <ShiftPopover
                      form={form}
                      onAddBreak={onAddBreak}
                      onDeleteShift={() => onDeleteShift(shiftConfig)}
                      canDelete={shiftsForms.length > 1}
                    />
                  }
                />
              )}
            </>
          )
        })}
      </Box>
    </Box>
  )
}

export default observer(DayInput)
